import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostBuilding_groups_groupIdImage = z.any()
export type TagsPostBuilding_groups_groupIdImage = z.infer<typeof tagsPostBuilding_groups_groupIdImage>

export const consumesPostBuilding_groups_groupIdImage = z.any()
export type ConsumesPostBuilding_groups_groupIdImage = z.infer<typeof consumesPostBuilding_groups_groupIdImage>

export const paramsPostBuilding_groups_groupIdImage = z.object({ "groupId": z.string().uuid() })
export type ParamsPostBuilding_groups_groupIdImage = z.infer<typeof paramsPostBuilding_groups_groupIdImage>

export const querystringPostBuilding_groups_groupIdImage = z.object({ "municipalityId": z.string().uuid() })
export type QuerystringPostBuilding_groups_groupIdImage = z.infer<typeof querystringPostBuilding_groups_groupIdImage>

export const bodyPostBuilding_groups_groupIdImage = z.object({ "image": z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string(), "file": z.any(), "type": z.string().optional() }) })
export type BodyPostBuilding_groups_groupIdImage = z.infer<typeof bodyPostBuilding_groups_groupIdImage>

export const responsePostBuilding_groups_groupIdImage = z.object({ "payload": z.object({ "id": z.string().uuid(), "image": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostBuilding_groups_groupIdImage = z.infer<typeof responsePostBuilding_groups_groupIdImage>

interface IPostBuilding_groups_groupIdImage extends BaseMethodType {
  tags: TagsPostBuilding_groups_groupIdImage,
  consumes: ConsumesPostBuilding_groups_groupIdImage,
  params: ParamsPostBuilding_groups_groupIdImage,
  querystring: QuerystringPostBuilding_groups_groupIdImage,
  body: BodyPostBuilding_groups_groupIdImage,
  response: ResponsePostBuilding_groups_groupIdImage
}
export const tagsGetBuilding_groups_groupIdImage = z.any()
export type TagsGetBuilding_groups_groupIdImage = z.infer<typeof tagsGetBuilding_groups_groupIdImage>

export const paramsGetBuilding_groups_groupIdImage = z.object({ "groupId": z.string().uuid() })
export type ParamsGetBuilding_groups_groupIdImage = z.infer<typeof paramsGetBuilding_groups_groupIdImage>

export const querystringGetBuilding_groups_groupIdImage = z.object({ "municipalityId": z.string().uuid() })
export type QuerystringGetBuilding_groups_groupIdImage = z.infer<typeof querystringGetBuilding_groups_groupIdImage>

export const responseGetBuilding_groups_groupIdImage = z.any()
export type ResponseGetBuilding_groups_groupIdImage = z.infer<typeof responseGetBuilding_groups_groupIdImage>

interface IGetBuilding_groups_groupIdImage extends BaseMethodType {
  tags: TagsGetBuilding_groups_groupIdImage,
  params: ParamsGetBuilding_groups_groupIdImage,
  querystring: QuerystringGetBuilding_groups_groupIdImage,
  response: ResponseGetBuilding_groups_groupIdImage
}
export const URL = '/building-groups/:groupId/image'
export const validation = {
  post: {
    tags: tagsPostBuilding_groups_groupIdImage,
    consumes: consumesPostBuilding_groups_groupIdImage,
    params: paramsPostBuilding_groups_groupIdImage,
    querystring: querystringPostBuilding_groups_groupIdImage,
    body: bodyPostBuilding_groups_groupIdImage,
    response: responsePostBuilding_groups_groupIdImage
  },
  get: {
    tags: tagsGetBuilding_groups_groupIdImage,
    params: paramsGetBuilding_groups_groupIdImage,
    querystring: querystringGetBuilding_groups_groupIdImage,
    response: responseGetBuilding_groups_groupIdImage
  }
}
export interface Building_groups_groupIdImage extends BaseRouteType {
  post: IPostBuilding_groups_groupIdImage,
  get: IGetBuilding_groups_groupIdImage
}